import * as React from "react";
const SvgObjectTree = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M3 2 h8 v6 h-3 v2 h5 v-2 h8 v6 h-8 v-2 h-5 v6 h5 v-2 h8 v6 h-8 v-2 h-7 v-12 h-3z", fill: "currentColor" }));
export default SvgObjectTree;
